import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import LoadingContext from "../../contexts/Loading";
import "./style.scss";
export default function Loading() {
    return (_jsx(LoadingContext.Consumer, { children: ({ isLoading }) => {
            return (_jsxs("div", { className: isLoading ? "loading-modal loading-opacity" : "loading-modal", children: [_jsx("button", { id: "btn-overlay-carregamento", className: "loading-modal__overlay", onClick: (e) => e.stopPropagation() }), _jsxs("div", { className: "loading-modal__content", children: [_jsx("div", { className: "loading-modal__content__icon", children: _jsx(CircularProgress, {}) }), _jsx("div", { className: "loading-modal__content__text", children: _jsx("p", { children: "Carregando..." }) })] })] }));
        } }));
}
